// extracted by mini-css-extract-plugin
module.exports = {"heading":"PrivacyPolicyPage_heading__2dqAr","content":"PrivacyPolicyPage_content__1itHM"};